import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AsyncStorage from '@react-native-async-storage/async-storage';

import OneTimePassword from '../../components/register/OneTimePassword';
import Languages from '../../constants/Languages';
import * as Actions from '../../store/Actions';

class OtpCodeScreen extends Component {
  static propTypes = {
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super();
    const { actions } = props;
    actions.clearError();
  }

  goNext = (code, deviceId) => {
    const { actions, navigation, registration } = this.props;
    const { phone, language, flow } = registration;
    const { user: beforeUser } = registration;
    actions.tryCode(phone, code, deviceId, language, beforeUser, (user) => {
      // do we have the edge case that an existing phone user
      // tried to login with a new email?
      if (user && user.id && beforeUser.id !== user.id && beforeUser.email && beforeUser.email !== '') {
        actions.mergeUsers(beforeUser.email, phone, () => {
          if (user.docs && user.docs.length) {
            navigation.navigate('TermsPrivacy');
          } else if (user.onboarding_complete) {
            AsyncStorage.setItem('onboarded', '1').then(() => {
              actions.refreshRedux();
              navigation.navigate('a');
            });
          } else {
            navigation.navigate('UserDetails');
          }
        });
        // normal cases
      } else {
        switch (flow) {
          case 'new_phone':
            navigation.navigate('EnterEmail');
            break;
          case 'new_email':
            navigation.navigate('TermsPrivacy');
            break;
          case 'existing_phone':
          case 'existing_email':
            if (flow === 'existing_phone' && !user.email && !user.skip_email_ask) {
              navigation.navigate('EnterEmail');
            } else if (user.docs && user.docs.length) {
              navigation.navigate('TermsPrivacy');
            } else if (user.onboarding_complete) {
              AsyncStorage.setItem('onboarded', '1').then(() => {
                actions.refreshRedux();
                navigation.navigate('a');
              });
            } else {
              navigation.navigate('UserDetails');
            }
            break;
          default:
            navigation.navigate('TermsPrivacy');
        }
      }
    });
  };

  goBack = () => {
    const { navigation } = this.props;
    navigation.navigate('Language');
  };

  sendOtp = (phone, deviceId) => {
    const { actions } = this.props;
    actions.sendOtp(phone, deviceId);
  };

  render() {
    const { registration, actions } = this.props;
    const { language, error } = registration;
    const translation = Languages.translations[language?.name || 'en'];

    return (
      <OneTimePassword
        translation={translation}
        registration={registration}
        goBack={this.goBack}
        goNext={this.goNext}
        resendCode={this.sendOtp}
        closeOtpSentAlert={actions.closeOtpSentAlert}
        error={error}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OtpCodeScreen);
